<template>
  <div class="result-wrap">
    <div class="result-top">
      <img class="result-title" src="@/assets/img/result-title.png" />
      <div class="result-desc">{{ tip }}</div>
      <img
        :class="['result-img', Number(score) > 3 ? '' : 'filter-gray']"
        src="@/assets/img/result-icon.png"
        alt="结果奖杯icon"
      />
      <div class="result-divider"></div>
      <van-row
        class="score-items"
        type="flex"
        justify="center"
        align="center"
        gutter="50"
      >
        <van-col span="8">
          <div class="score-msg">{{ score }}/{{ totalScore }}</div>
          <div class="score-label">答对</div>
        </van-col>
        <van-col span="8">
          <div class="score-msg">{{ score }}</div>
          <div class="score-label">得分</div>
        </van-col>
        <van-col span="8">
          <div class="score-msg">{{ duration }}</div>
          <div class="score-label">时间</div>
        </van-col>
      </van-row>
    </div>
    <van-row class="btns" type="flex" gutter="8">
      <van-col span="12">
        <div class="btn-outer" @click="$router.replace('/question')">
          <div class="btn-inner">继续答题</div>
        </div>
      </van-col>
      <van-col span="12">
        <div class="btn-outer" @click="shareResult">
          <div class="btn-inner">炫耀成绩</div>
        </div>
      </van-col>
      <van-col span="24">
        <div class="btn-outer" @click="goErrors">
          <div class="btn-inner">查看题目解析</div>
        </div>
      </van-col>
      <van-col span="24">
        <div class="btn-outer" @click="$router.replace('/')">
          <div class="btn-inner">返回</div>
        </div>
      </van-col>
    </van-row>
    <van-dialog
      v-model="showPrizePopup"
      class="draw-dialog"
      title=""
      :close-on-click-overlay="true"
      :show-confirm-button="false"
    >
      <div class="draw-dialog_content">
        <div class="draw-label">恭喜您！</div>
        <div class="draw-info">答对{{ score }}题，获得1次抽奖机会</div>
        <div class="draw-btn" @click="doDraw"></div>
      </div>
    </van-dialog>
    <!-- <van-dialog
      v-model="kepuConfirmDialog"
      class="register-dialog"
      title=""
      :close-on-click-overlay="true"
      :show-confirm-button="false"
    >
      <div class="register-dialog_content">
        <div class="register-label">恭喜您！</div>
        <div class="register-info">答对{{ score }}题，获得1次抽奖机会</div>
        <img class="register-icon" src="@/assets/img/register-icon.png" />
        <div class="register-tip">
          <span>温馨提示</span>
          <img
            src="@/assets/img/register-tip-icon.png"
            @click="showTips = !showTips"
          />
        </div>
        <div class="register-tip-desc">
          注册山西省科普员并审核通过后可参与抽奖
        </div>
        <div class="register-operation">
          <van-button
            class="close-btn"
            type="default"
            @click="kepuConfirmDialog = false"
            >关闭</van-button
          >
          <van-button class="confirm-btn" type="info" @click="doRegister"
            >同意注册并抽奖</van-button
          >
        </div>
        <div v-if="showTips" class="register-tip-info">
          科普中国信息员是在科普中国平台实名注册认证并经常性开展科普信息传播的用户，用户通过微信群、QQ群、公众号等社交渠道将科普信息传递给周边群众，积极配合有关部门参与各类科技教育与传播普及活动。
        </div>
        <van-icon
          class="cross-icon"
          name="cross"
          @click="kepuConfirmDialog = false"
        />
      </div>
    </van-dialog> -->
    <van-dialog
      v-model="shareDialog"
      class="share-dialog"
      title=""
      :show-confirm-button="false"
      :close-on-click-overlay="true"
    >
      <div class="dialog_content">
        <div>
          <img
            style="width: 100%; height: 100%; vertical-align: middle"
            id="cerImg"
            :src="imgSrc"
          />
        </div>
        <img
          class="close-btn"
          src="@/assets/img/close-btn.png"
          @click="shareDialog = false"
        />
      </div>
    </van-dialog>
    <div id="shareImg">
      <div style="text-align: center">
        <div class="share-top">
          <img v-if="Number(score) > 3" src="@/assets/img/result-icon.png" />
          <img v-else src="@/assets/img/result-icon-grey.png" />
          <div class="top-label">您的朋友在</div>
          <div class="top-area">
            《2026年山西省公众科学素质网络知识竞赛》<br />获得
          </div>
          <div class="top-score">
            “{{ Number(score) === 5 ? "满分" : score
            }}<span v-if="Number(score) !== 5" class="score-measure">分</span>”
          </div>
          <div class="top-time">
            本次答题用时：{{ duration | durationFormat }}
          </div>
        </div>
        <div class="share-divider">
          <img src="@/assets/img/card-divider.png" />
        </div>
        <div class="qr-code">
          <img :src="qrCodeSrc" />
          <div>使用微信扫描识别二维码即刻参与答题</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import html2canvas from "html2canvas";
export default {
  data() {
    return {
      loading: false,
      score: 0,
      totalScore: 5,
      duration: 0,
      // 抽奖弹出层
      showPrizePopup: false,
      // 抽中红包弹窗
      shareDialog: false,
      imgSrc: "",
      // kepuConfirmDialog: false,
      showTips: false,
    };
  },
  computed: {
    type() {
      return Number(this.$route.query.type);
    },
    // 根据打包环境区分二维码：线上环境用 qr-code.png，其余用 qr-code2.png
    qrCodeSrc() {
      if (process.env.VUE_APP_ENV === "production") {
        return require("@/assets/img/qr-code.png");
      }
      return require("@/assets/img/qr-code2.png");
    },
    tip() {
      switch (Number(this.score)) {
        case 0:
          return "失败乃成功之母，加油！";
        case 1:
          return "您已迈出成功的第一步，继续突破吧！";
        case 2:
          return "您已迈出成功的第一步，继续突破吧！";
        case 3:
          return "胜利在望，加油！";
        case 4:
          return "胜利在望，加油！";
        case 5:
          return "优秀如你，再接再厉！";
        default:
          return "优秀如你，再接再厉！";
      }
    },
  },
  methods: {
    doDraw() {
      // try {
      //   const res = await this.$axios.post(`/Redpackets/lotteryDraw`);
      //   this.showPrizePopup = false;
      //   if (res.data.money) {
      //     this.redPackDialog = true;
      //   } else {
      //     this.missDialog = true;
      //   }
      //   console.log(res);
      // } catch (error) {
      //   this.missDialog = true;
      //   console.log(error);
      // }
      this.$router.replace(
        `/draw?score=${this.score}&duration=${this.duration}&type=1`
      );
    },
    /**
     * 获取答题结果
     */
    async getResult() {
      try {
        this.$toast.loading({
          message: "获取结果中...",
          forbidClick: true,
        });
        this.loading = true;
        const res = await this.$axios.post(`/Question/getGrade`, {
          id: this.$store.state.user.id,
          sign: this.$route.query.sign,
        });
        this.loading = false;
        const { score, duration, total } = res.data;
        this.score = score;
        this.duration = duration;
        this.totalScore = total ?? 5;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: error.errorMsg || "获取结果失败！",
          duration: 2000,
        });
        console.log(error);
      } finally {
        this.$toast.clear();
      }
    },
    async hasDrawChance() {
      try {
        // if (Number(this.score) >= 3) {
        const res = await this.$axios.post(`/Redpackets/getLotteryNum`);
        if (res.data.success == 1) {
          this.showPrizePopup = true;
        }
        //  else if (res.data.success == 2) {
        //   this.kepuConfirmDialog = true;
        // }
        // }
      } catch (error) {
        console.log(error);
      }
    },
    // 炫耀成绩
    shareResult() {
      setTimeout(() => {
        this.$nextTick(() => {
          html2canvas(document.querySelector("#shareImg"), {
            dpi: 96, // 分辨率
            scale: 1, // 设置缩放
            useCORS: true,
            bgcolor: "#ffff", // 应该这样写
            logging: false, // 打印日志用的 可以不加默认为false
          })
            .then((canvas) => {
              return new Promise((resolve) => {
                canvas.toBlob((blob) => resolve(blob));
              });
            })
            .then((blob) => {
              const fr = new FileReader();
              fr.readAsDataURL(blob);
              fr.onload = (e) => {
                this.imgSrc = e.target.result;
              };
              // const url = URL.createObjectURL(blob);
              // this.imgSrc = url;
              this.shareDialog = true;
            });
        });
      }, 100);
    },
    goErrors() {
      this.$router.replace(
        `/errors?type=2&score=${this.score}&duration=${this.duration}`
      );
    },
    async doRegister() {
      try {
        // if (Number(this.score) > 3) {
        await this.$axios.post(`/user/registerScience`);
        // this.kepuConfirmDialog = false;
        this.doDraw();
        // }
      } catch (error) {
        console.log(error);
      }
    },
    async checkFirst() {
      try {
        await this.$axios.post(`/Question/checkFirst`, {
          uid: this.$store.state.user.user.id,
        });
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    if (Number(this.$route.query.type) === 2) {
      this.score = this.$route.query.score;
      this.duration = this.$route.query.duration;
    } else {
      this.getResult().then(() => {
        this.hasDrawChance();
      });
      this.checkFirst();
    }
  },
};
</script>
<style lang="scss" scoped>
.result-wrap {
  position: relative;
  padding: 50px 20px 0;
  @include content-bg;

  .draw-dialog {
    width: 228px;
    background-color: transparent;

    .draw-dialog_content {
      position: relative;
      width: 100%;
      height: 323px;
      text-align: center;
      background: url("~@/assets/img/draw-icon.png") no-repeat top center/100%;

      .draw-label {
        padding-top: 103px;
        font-size: 20px;
        font-weight: 600;
        line-height: 25px;
        color: #ef1c00;
      }

      .draw-info {
        margin-top: 3px;
        font-size: 14px;
        line-height: 25px;
        color: #ef1c00;
      }

      .draw-btn {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 40px;
      }
    }
  }

  .btns {
    padding: 10px 20px 0;
  }

  .share-dialog {
    width: 90%;
    overflow: visible;
    border-radius: 0;

    .dialog_content {
      position: relative;

      .close-btn {
        position: absolute;
        top: calc(100% + 10px);
        left: calc(50% - 15px);
        width: 30px;
        height: 30px;
        cursor: pointer;
      }
    }
  }

  .btn-outer {
    margin-top: 13px;
  }

  // .register-dialog {
  //   width: 263px;

  //   .register-dialog_content {
  //     position: relative;
  //     padding: 15px 18px 20px;
  //     text-align: center;
  //     background: url("~@/assets/img/register-bg.png") no-repeat top center/100%;

  //     .register-label {
  //       font-size: 25px;
  //       font-weight: 600;
  //       line-height: 44px;
  //       color: #2852fa;
  //     }

  //     .register-info {
  //       margin-top: 3px;
  //       font-size: 17px;
  //       font-weight: 500;
  //       line-height: 24px;
  //     }

  //     .register-icon {
  //       width: 95px;
  //       margin-top: 22px;
  //     }

  //     .register-tip {
  //       margin-top: 15px;
  //       font-size: 13px;
  //       line-height: 15px;
  //       text-align: justify;

  //       img {
  //         width: 15px;
  //         margin-left: 4px;
  //         vertical-align: top;
  //         cursor: pointer;
  //       }
  //     }

  //     .register-tip-desc {
  //       margin-top: 6px;
  //       font-size: 13px;
  //       line-height: 15px;
  //       text-align: justify;
  //     }

  //     .register-operation {
  //       display: flex;
  //       align-items: center;
  //       justify-content: space-between;
  //       margin-top: 17px;

  //       .close-btn {
  //         height: 36px;
  //         color: #666;
  //         border-color: #979797;
  //         border-radius: 7px;
  //       }

  //       .confirm-btn {
  //         height: 36px;
  //         background: linear-gradient(90deg, #0579fe 0%, #0829fd 100%), #d8d8d8;
  //         border-radius: 7px;
  //       }
  //     }

  //     .register-tip-info {
  //       position: absolute;
  //       top: 21px;
  //       right: 18px;
  //       left: 18px;
  //       padding: 17px 8px;
  //       font-size: 14px;
  //       line-height: 21px;
  //       color: #fff;
  //       text-align: left;
  //       background: rgba(36, 36, 36, 0.7);
  //       border-radius: 10px;
  //     }

  //     .cross-icon {
  //       position: absolute;
  //       top: 11px;
  //       right: 11px;
  //       font-size: 11px;
  //       color: #fff;
  //       cursor: pointer;
  //     }
  //   }
  // }

  .result-top {
    padding: 35px 12px 20px;
    text-align: center;
    background: #fff;
    border: 2px solid #000;
    border-radius: 6px;

    .result-title {
      width: 114px;
      height: 27px;
    }

    .result-desc {
      margin-top: 12px;
      font-size: 17px;
      font-weight: 400;
      color: #4581fc;
    }

    .result-img {
      width: 199px;
      height: 185px;
      margin-top: 12px;
    }

    .result-divider {
      margin-top: 12px;
      border-bottom: 2px dotted #e5e5e5;
    }

    .score-items {
      padding: 15px 20px 0;

      .score-msg {
        font-size: 21px;
        line-height: 36px;
        color: #ff2609;
      }

      .score-label {
        font-size: 18px;
        line-height: 36px;
        color: #000;
      }
    }
  }

  #shareImg {
    position: absolute;
    left: 99999px;
    width: 566px;
    padding: 96px 34px 40px;
    background: url("~@/assets/img/plain-bg.png") no-repeat top center/100%;

    .share-top {
      background: #fff;
      border-radius: 18px 18px 0 0;

      img {
        width: 274px;
        height: 264px;
      }

      .top-label {
        margin-top: 26px;
        font-size: 34px;
        font-weight: 600;
        line-height: 38px;
        color: #333;
      }

      .top-area {
        margin-top: 8px;
        font-size: 25px;
        line-height: 28px;
        color: #333;
      }

      .top-score {
        margin-top: 24px;
        font-size: 64px;
        font-weight: 600;
        line-height: 76px;
        color: #46a87d;

        .score-measure {
          font-size: 28px;
          font-weight: 400;
          line-height: 32px;
          color: #46a87d;
        }
      }

      .top-time {
        padding: 24px 0 50px;
        font-size: 25px;
        font-weight: 400;
        line-height: 28px;
        color: #46a87d;
      }
    }

    .share-divider {
      margin: -1px 0 -9px;

      img {
        width: 566px;
      }
    }

    .qr-code {
      background: #ffff;
      border-radius: 0 0 18px 18px;

      img {
        width: 150px;
        height: 150px;
      }

      div {
        padding: 20px 0 14px;
        font-size: 20px;
        line-height: 24px;
        color: #333;
      }
    }
  }
  .filter-gray {
    filter: grayscale(70%);
  }
}
</style>
